import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import UIkit from 'uikit'
import introJs from 'intro.js'

// Containers
import BrowserEditorArea from 'app/views/containers/BrowserEditorArea'
import CountdownTimer from 'app/views/components/CountdownTimer'
import QuizBrowserLoader from 'app/views/components/QuizBrowserLoader'

// Redux
import {
  getQuizStep,
  postQuizAnswer,
} from 'app/state/modules/quiz'

// Utils
import analytics from 'app/views/utils/analytics'
import isMobileDevice from 'app/views/utils/mobile'


class QuizTour extends React.PureComponent {
  constructor(props) {
    super(props)

    this.state = {}

    this.handleStartTour = this.handleStartTour.bind(this)
    this.handleSkip = this.handleSkip.bind(this)
    this.handleReset = this.handleReset.bind(this)
  }

  componentDidMount() {
    analytics.page('quiz-tour')
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.proxyStatus === 'listening') {
      if (!isMobileDevice()) {
        this.handleStartTour()
      }
    }
    if (this.props.quiz.quiz.uuid === '' && nextProps.quiz.quiz.uuid !== '') {
      this.props.getQuizStep(
        this.props.match.params.id,
        nextProps.quiz.quiz.questions[this.props.quiz.currentQuestion].uuid,
      )
    }
  }

  handleStartTour() {
    const tour = introJs()
      .setOptions({
        skipLabel: 'Skip Tour',
        showStepNumbers: false,
        hideNext: true,
        hidePrev: true,
        exitOnOverlayClick: false,
        steps: [
          {
            element: document.querySelectorAll('#quiz-question')[0],
            intro: `
              <div class="uk-padding-small">
                <h4>Question</h4>
                <p>The question will always be found at the top of the page.</p>
              </div>
            `,
            tooltipPosition: 'bottom',
            position: 'bottom',
          }, {
            element: document.querySelectorAll('#tour-timer')[0],
            intro: `
              <div class="uk-padding-small">
                <h4>Countdown Timer</h4>
                <p>This timer lets you know how much time is left to answer the question.</p>
                <p>You will receive bonus points for answering the question quickly (as long as you still get it right)!</p>
              </div>
            `,
            tooltipPosition: 'left',
            position: 'left',
          }, {
            element: document.querySelectorAll('#tour-language-selector')[0],
            intro: `
              <div class="uk-padding-small">
                <h4>Select your language</h4>
                <p>Choose which language you would like to use to patch the application and pass the assessment.</p>
              </div>
            `,
            tooltipPosition: 'right',
            position: 'right',
          }, {
            element: document.querySelectorAll('#editor-sidebar')[0],
            intro: `
              <div class="uk-padding-small">
                <h4>Code Editor</h4>
                <p>
                  Edit this code to fix the vulnerability in the sandbox application to the right.
                </p>
              </div>
            `,
            position: 'right',
          }, {
            element: document.querySelectorAll('#tour-submit-patch')[0],
            intro: `
              <div class="uk-padding-small">
                <h4>Submit Patch</h4>
                <p>
                  Once you have edited the code above, submit the patch to try out your fix.
                </p>
              </div>
            `,
            position: 'top',
          }, {
            element: document.querySelectorAll('#tour-submit-answer')[0],
            intro: `
              <div class="uk-padding-small">
                <h4>Submit Answer</h4>
                <p>
                  Once you have submitted a patch and tested it, you can submit your final answer and move on to the next question.
                </p>
              </div>
            `,
            position: 'top',
          }, {
            element: document.querySelectorAll('#proxy-intercept')[0],
            intro: `
              <div class="uk-padding-small">
                <h4>Intercept Requests</h4>
                <p>
                  To turn on the proxy ensure the "Intercept Requests" button is checked. This will hold HTTP requests sent until the Submit Request button is hit. It is a good idea to explore web applications with intercept off so it doesn't slow you down. Once you start testing it is a good idea to have it turned on to analyze requests.
                </p>
              </div>
            `,
            position: 'bottom',
          }, {
            element: document.querySelectorAll('#browser')[0],
            intro: `
              <div class="uk-padding-small">
                <h4>Application Sandbox</h4>
                <p>
                  This panel is your application sandbox. It acts very similar to a normal browser with forward and back buttons. You can view the source code of the browser by clicking on "View Source". To get back to the browser click "View Browser".
                </p>
              </div>
            `,
            position: 'left',
          }, {
            element: document.querySelectorAll('#proxy-request-button')[0],
            intro: `
              <div class="uk-padding-small">
                <h4>Proxy</h4>
                <p>This button expands the web application proxy where you will man-in-the-middle HTTP requests and responses from/to the application browser. The proxy will also automatically pop out when you are intercepting requests.</p>
              </div>
            `,
            highlightClass: 'tour-dark',
            position: 'left',
          }, {
            element: document.querySelectorAll('#proxy-history-button')[0],
            intro: `
              <div class="uk-padding-small">
                <h4>Proxy History</h4>
                <p>The History tab in the proxy shows the HTTP requests as well as the responses from those requests. If you click on the plus next to the request you will be able to see the HTTP request and the corresponding responses. This is very useful in seeing responses based on past requests.</p>
              </div>
            `,
            highlightClass: 'tour-dark',
            position: 'right',
          }, {
            element: document.querySelectorAll('#proxy-reset')[0],
            intro: `
              <div class="uk-padding-small">
                <h4>Reset Sandbox</h4>
                <p>If you break the web application in your browser sandbox and want a fresh start, clicking Reset Sandbox will give you a brand new web application.</p>
              </div>
            `,
            position: 'bottom',
          },
        ],
      })

    tour.onexit(() => {
      this.props.history.push(`/quiz/${this.props.match.params.id}/steps`)
    })

    tour.start()
  }

  handleSkip() {
    UIkit.modal('#modal-quiz-tour').hide()
    this.props.history.push(`/quiz/${this.props.match.params.id}/steps`)
  }

  handleReset() {
    this.setState({
      resetDisabled: true
    }, () => {
      setTimeout(() => {
        this.setState({ resetDisabled: false })
      }, 5000)
      if (this.state.resetDisabled === true) {
        this.props.replReset()
      }
    })

  }

  render() {
    if (isMobileDevice()) {
      return (
        <div className="uk-section">
          <div className="uk-container uk-text-center">
            <h3 className="uk-text-bold">Looks like you are on mobile...</h3>
            <p>
              Thanks for checking out our Secure Coding IQ Assessment while on the go, but our tools
              are not available on mobile.
            </p>
            <Link className="uk-button uk-button-primary" to="/">Back To Homepage</Link>
          </div>
        </div>
      )
    }
    return (
      <div>
        <div className="uk-cover-container uk-background-secondary uk-padding-large uk-padding-remove-bottom uk-padding-remove-top uk-light">
          <div className="uk-section uk-padding-remove">
            <div className="uk-text-center">
              <h2 id="quiz-question">Can you fix the bug on this page?</h2>
              <h4 className="uk-margin-remove-top">&nbsp;</h4>
            </div>
            <CountdownTimer
              className="uk-position-right uk-padding-small"
              time={270}
              id="tour-timer"
            />
          </div>
        </div>

        <div className="uk-cover-container">
          {this.props.proxyStatus === 'init' && <QuizBrowserLoader
            resetDisabled={this.state.resetDisabled}
            handleReset={this.props.handleReset}
          />}
          <BrowserEditorArea
            handleClickBack={(stepId) => { this.handleClickBack(stepId) }}
            handleClickCircle={(stepId) => { this.handleClickCircle(stepId) }}
            handleClickNext={(stepId) => { this.handleClickNext(stepId) }}
            handleClickDone={(stepId) => { this.handleClickDone(stepId) }}
            onSubmitClick={() => { }}
            steps={[]}
            hints={[]}
            name="name"
            ecsTaskDefinition="was1_sqli"
            lessonCompletionURL="/register"
            hasTest={false}
            lessonCompletionText="Create an Account"
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.authenticationStatus === 'LOGGED_IN',
  quiz: state.quiz,
  question: state.quiz.question,
  questions: state.quiz.quiz.questions,
  currentQuestion: state.quiz.currentQuestion,
  engine: state.repl.engine,
  proxyStatus: state.proxy.status,
})

const mapDispatchToProps = dispatch => ({
  getQuizStep: (quizId, questionId) => { dispatch(getQuizStep(quizId, questionId)) },
  postQuizAnswer: (quizId, questionId, answer, code, engine) => { dispatch(postQuizAnswer(quizId, questionId, answer, code, engine)) },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizTour))
